// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true*/
import hopt from 'hola_opt';
import zurl from 'zurl';
import zutil from 'zutil';
import {data_layer_obj} from '../types';

// eslint-disable-next-line
let dl: typeof window.dataLayer;

const rename = (event: string)=>{
    const qs_o = zurl.qs_parse(location.search.substr(1), {safe: true});
    const is_test = !!+qs_o.test;
    const gtm_id = zutil.get(hopt, 'www_hola.gtm.id');
    const is_live = window.google_tag_manager &&
        !!window.google_tag_manager[gtm_id];
    return `${event}${!is_test && is_live ? '' : '_test'}`;
};

export const push = (opt: data_layer_obj)=>{
    if (!dl)
        return;
    if (opt.event)
        opt.event = rename(opt.event);
    dl.push(opt);
};

const init = ()=>{
    if (dl || window._is_ssr_render)
        return;
    dl = window.dataLayer = window.dataLayer || [];
};

init();

export default {push};
